import { useApi } from 'api'

export const useTrackerEvent = () => {
  const apiClient = useApi().apiClient

  return apiClient.useMutation('trackerEvent')
}
